//for choose button redirect to product page functionality
const targetNode = document.body; // or a more specific parent element
const config = { childList: true, subtree: true };

const callback = function(mutationsList) { 
    for (let mutation of mutationsList) {
        if (mutation.type === 'childList') {
            const submitButton = document.querySelector('.quick-add__submit');
            if (submitButton && pickystory) {
                let temp2 = pickystory.bundles;
                if (Array.isArray(temp2) && temp2.length > 0) {
                for(i=0;i<temp2.length;i++){
                
                    let formElement = jQuery(`[value="${temp2[i].compoundProduct.product.id}"]`).parent();
                        
                    formElement.addClass('pickstory-bundle')
                        .find('.quick-add__submit')
                        .css({
                            'flex-direction': 'column',
                            'display': 'flex',
                            'align-items': 'center',
                            'justify-content': 'center',
                            'text-align': 'center'
                        })
                        .find('.add-spc')
                        .text('Choose Options')
                        .end()
                        .find('.price')
                        .remove();

                    // Add click event for redirection inside the callback itself
                    formElement.find('.quick-add__submit').off("click").on("click", function (event) {
                        let buttonText = $(this).find('.add-spc').text().trim();
                        
                        if (buttonText === "Choose Options") {
                            event.preventDefault(); // Prevent form submission

                            // Find the closest '.card' and get the <a> tag's href
                            let redirectUrl = $(this).closest('.card').find('a').attr('href');
  
                            if (redirectUrl) {
                                window.location.href = redirectUrl; // Redirect to the extracted URL
                            }
                        }
                    });
                }

                observer.disconnect(); // stop observing after detecting the element
                return; // exit the callback once the element is found
            }
            }
        }
    }
};

const observer = new MutationObserver(callback);
observer.observe(targetNode, config);

document.addEventListener("click", function(event) {
    if (event.target.closest('.loadMoreBtn')) {
        // Ensure observer continues to detect changes when new products load
        observer.observe(targetNode, config);
    }
});